module.exports = __webpack_public_path__ + "static/media/Smart Emission Calculation.47b623d2.svg";